import { render } from "./Saturation.vue?vue&type=template&id=659348d8"
import script from "./Saturation.vue?vue&type=script&lang=js"
export * from "./Saturation.vue?vue&type=script&lang=js"

import "./Saturation.vue?vue&type=style&index=0&id=659348d8&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__